import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { parseDateToString } from '@utils/helpers';

import { CalendarButton } from './CalendarButton';

const HiddenInput = styled.input`
  width: 0;
  height: 0;
  position: absolute;
  left: -100vw;
  top: -100vh;
`;

export class NativeDatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.inputDatePickerRef = React.createRef();
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleButtonClick() {
    this.inputDatePickerRef.current.focus();
    this.inputDatePickerRef.current.click();
  }

  render() {
    const { onChange, selected, min, max } = this.props;

    return (
      <>
        <CalendarButton type="button" onClick={this.handleButtonClick} />
        <HiddenInput
          value={selected}
          ref={this.inputDatePickerRef}
          min={min && parseDateToString(min)}
          max={max && parseDateToString(max)}
          onChange={onChange}
          type="date"
        />
      </>
    );
  }
}

NativeDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
};

NativeDatePicker.defaultProps = {
  selected: new Date(),
  min: null,
  max: null,
};
